import React, { Fragment } from 'react';
import { css } from 'twin.macro';
import { AiOutlineUp, AiOutlineDown } from 'react-icons/ai';

const cycleBtnStyles = css`
    background: none;
    border: none;
    color: #50aeb0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    outline: none;
    padding: 2px;
    transition: transform 0.1s;
    &:hover {
        transform: scale(1.1);
    }
    border: 1px solid #50aeb0;
    border-radius: 5px;
`;

const cycleHighlight = (direction) => {
    try {
        const highlights = document.querySelectorAll('.search-highlight');
        if (!highlights.length) return;

        const activeEl = document.querySelector('.search-highlight.active-highlight');
        let currentHighlightIndex = -1;

        if (activeEl) {
            currentHighlightIndex = Array.from(highlights).indexOf(activeEl);
        }

        if (direction === 'next') {
            if (currentHighlightIndex === -1) {
                currentHighlightIndex = 0;
            } else if (currentHighlightIndex < highlights.length - 1) {
                currentHighlightIndex++;
            }
        } else {
            if (currentHighlightIndex === -1) {
                currentHighlightIndex = highlights.length - 1;
            } else if (currentHighlightIndex > 0) {
                currentHighlightIndex--;
            }
        }

        highlights.forEach((el) => {
            el.classList.remove('active-highlight');
            el.style.border = '';
            el.style.boxShadow = 'none';
            el.style.padding = '0 2px';
        });

        const currentEl = highlights[currentHighlightIndex];
        if (currentEl) {
            currentEl.classList.add('active-highlight');
            currentEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            currentEl.style.border = '2px solid black';
        }
    } catch (error) {
        console.error('cycleHighlight', error);
    }
};

const SearchHighlight = ({}) => {
    return (
        <Fragment>
            <button
                css={cycleBtnStyles}
                className="ml-2"
                onClick={() => cycleHighlight('prev')}
                title="Previous match"
                type="button"
            >
                <AiOutlineUp className="view" size={16} />
            </button>
            <button
                css={cycleBtnStyles}
                className="ml-2"
                onClick={() => cycleHighlight('next')}
                title="Next match"
                type="button"
            >
                <AiOutlineDown className="view" size={16} />
            </button>
        </Fragment>
    );
};

export default SearchHighlight;
